import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

/**
 * Helper function to get a date that is a specified number of days ago
 * Properly handles timezone to ensure consistent date calculations
 * @param days - Number of days to go back from today
 * @returns Date object representing the date that many days ago in user's timezone
 */
export function getDaysAgo(days: number): Date {
  // Use dayjs to properly handle timezone-aware date calculations
  // This ensures the date is calculated in the user's timezone
  return dayjs().subtract(days, 'day').toDate()
}
